module.exports = __webpack_public_path__ + "static/media/sf-landmark-2.c43fb911.png";